<template>
    <div class="Rating">
        <ListTransition
            v-if="list"
            key="stars"
            tag="ul"
            class="Stars"
        >
            <li
                v-for="num in list"
                :key="num"
                class="StarsItem"
            >
                <WIcon
                    v-if="icon"
                    :id="`star-${num}`"
                    :icon="icon"
                    :color="checkColor(num)"
                    :size="iconSize"
                    class="Star"
                    :class="{ disabled }"
                    @mouseenter="handleMouseEnter(num)"
                    @mouseleave="handleMouseLeave(num)"
                    @click="!handleSelected(num)"
                />
            </li>
        </ListTransition>

        <div
            v-if="counter"
            class="Counter"
        >
            <Counter
                :number="hovered || value"
                size="12"
            />
        </div>
    </div>
</template>
<script>
import VueTypes from 'vue-types'
import { ListTransition } from '../Transitions'
import Counter from '../Counter/Counter.vue'

export default {
    name: 'Rating',
    components: {
        ListTransition,
        Counter,
    },
    props: {
        selected: VueTypes.number,
        stars: VueTypes.oneOfType([String, Number]).def(4),
        icon: VueTypes.string.def('close'),
        iconColor: VueTypes.string.def('grayMedium'),
        iconAccentColor: VueTypes.string.def('black'),
        iconSize: VueTypes.number.def(16),
        counter: VueTypes.bool.def(false),
        disabled: VueTypes.bool.def(false),
    },
    data () {
        return {
            value: null,
            hovered: null,
        }
    },
    computed: {
        list () {
            return Array.from({ length: parseInt(this.stars || 0, 0) }).map((s, num) => num + 1)
        },
    },
    watch: {
        selected (selected) {
            this.value = selected
        },
    },
    mounted () {
        if (this.selected) this.value = this.selected
    },
    methods: {
        checkColor (num) {
            const {
                value, hovered, iconColor, iconAccentColor,
            } = this
            if (hovered) return num <= hovered ? iconAccentColor : iconColor
            return value && num <= value ? iconAccentColor : iconColor
        },
        handleMouseEnter (num) {
            if (!this.disabled) this.hovered = num
        },
        handleMouseLeave () {
            if (!this.disabled) this.hovered = null
        },
        handleSelected (num) {
            if (!this.disabled) {
                this.value = num
                this.$emit('onClick', num)
            }
        },
    },
}
</script>
<style scoped lang="scss">
.AlignCenter {
    display: flex;
    align-items: center;
}

.Rating {
    @extend .AlignCenter;
}

.Stars {
    @extend .AlignCenter;
	list-style: none;
    &Item {
        & + & {
            margin-left: 20px;
        }
    }
}

.Star:not(.disabled) {
    cursor: pointer;
}

.Counter {
    margin-left: 20px;
}
</style>
